import "jquery-ui";
import "jquery-ui/ui/widgets/autocomplete";

import mSearch2 from "./../vendors/msearch2/msearch2.js";
global.mSearch2 = mSearch2;

(function () {
  const searchForm = document.querySelector(`form.msearch2`);

  if (!searchForm) {
    return;
  }

  mSearch2.Form.initialize(`form.msearch2`);
})();
